export const PAGE_SIZE_STORAGE_KEY = "automachine.pageSize";
export const LEGACY_ORDER_PAGE_SIZE_STORAGE_KEY = "automachine.orderPageSize";
export const DEFAULT_PAGE_SIZE = 50;
export const MIN_PAGE_SIZE = 1;
export const MAX_PAGE_SIZE = 1000;
export const PAGE_SIZE_OPTIONS = Object.freeze([50, 100, 500]);

function browserStorage() {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch (_error) {
    return null;
  }
}

export function isValidPageSize(value) {
  const numeric = Number(value);
  return Number.isFinite(numeric)
    && Number.isInteger(numeric)
    && numeric >= MIN_PAGE_SIZE
    && numeric <= MAX_PAGE_SIZE;
}

export function normalizePageSize(value, fallback = DEFAULT_PAGE_SIZE) {
  return isValidPageSize(value) ? Number(value) : fallback;
}

export function getPageSize(storage = browserStorage()) {
  if (!storage || typeof storage.getItem !== "function") {
    return DEFAULT_PAGE_SIZE;
  }

  try {
    const saved = storage.getItem(PAGE_SIZE_STORAGE_KEY);
    if (saved !== null) {
      return normalizePageSize(saved);
    }

    const legacy = storage.getItem(LEGACY_ORDER_PAGE_SIZE_STORAGE_KEY);
    if (isValidPageSize(legacy)) {
      const migrated = Number(legacy);
      if (typeof storage.setItem === "function") {
        try {
          storage.setItem(PAGE_SIZE_STORAGE_KEY, String(migrated));
        } catch (_error) {
          // Keep using the readable legacy preference when migration cannot persist.
        }
      }
      return migrated;
    }
  } catch (_error) {
    // Storage can be unavailable in privacy mode.
  }

  return DEFAULT_PAGE_SIZE;
}

export function savePageSize(value, storage = browserStorage()) {
  const normalized = normalizePageSize(value);
  if (storage && typeof storage.setItem === "function") {
    try {
      storage.setItem(PAGE_SIZE_STORAGE_KEY, String(normalized));
    } catch (_error) {
      // Keep the in-memory Vuex preference when storage is unavailable.
    }
  }
  return normalized;
}

export function pageSizeOptions(currentValue) {
  const current = normalizePageSize(currentValue);
  return [...new Set([...PAGE_SIZE_OPTIONS, current])].sort((a, b) => a - b);
}
